import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("cds_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const hadToken = !!localStorage.getItem("cds_token");
      localStorage.removeItem("cds_token");
      const p = window.location.pathname;
      const inApp = (p.startsWith("/admin") || p.startsWith("/customer")) && !p.includes("/login") && !p.includes("/register");
      if (hadToken && inApp) {
        window.location.href = p.startsWith("/customer") ? "/customer/login" : "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);
